import api from "Common/Client/Interceptor";

const BASE_URL = "/Manager/Profile";

export const fetchManagerProfile = async (token) => {
  return api.get(BASE_URL, {
    headers: {
      accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateManagerProfile = async (token, values, fileList) => {
  const formData = new FormData();
  if (fileList.length > 0 && fileList[0].originFileObj) {
    formData.append("ImageFile", fileList[0].originFileObj);
  }

  const queryParams = new URLSearchParams();
  queryParams.append("FirstName", values.firstName);
  queryParams.append("LastName", values.lastName);
  queryParams.append("PhoneNo", values.phoneNo);
  queryParams.append("Country", values.country);
  queryParams.append("State", values.state);
  queryParams.append("City", values.city);
  queryParams.append("ManagerCode", values.managerCode);

  // Handle business group properly
  if (values.businessGroupId === "Other") {
    if (values.otherGroupName) {
      queryParams.append("OtherBusinessGroup", values.otherGroupName);
    }
    // Don't send BusinessGroupId when "Other" is selected
  } else if (values.businessGroupId) {
    queryParams.append("BusinessGroupId", values.businessGroupId);
  }

  return api.put(`${BASE_URL}?${queryParams.toString()}`, formData, {
    headers: {
      accept: "*/*",
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const removeManagerProfilePicture = async (token) => {
  return api.delete(`${BASE_URL}/Picture`, {
    headers: { accept: "*/*", Authorization: `Bearer ${token}` },
  });
};
